/* FCC laminate collection: "Load more", mobile floating filter button and card delivery dates. No dependencies. */
(function () {
  if (window.__fccLaminate) return;
  window.__fccLaminate = true;

  // Load more (delegated so it keeps working after facets.js re-renders the grid)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fcc-next]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'Loading…';
    var url = new URL(btn.href, window.location.origin);
    url.searchParams.set('section_id', btn.dataset.section);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('product-grid');
        var items = doc.querySelectorAll('#product-grid > li:not(.fcc-grid__item--promo)');
        var frag = document.createDocumentFragment();
        items.forEach(function (li) { frag.appendChild(li); });
        grid.appendChild(frag);

        var shownEl = document.querySelector('[data-fcc-shown]');
        var newShown = doc.querySelector('[data-fcc-shown]');
        if (shownEl && newShown) shownEl.textContent = newShown.textContent;
        var bar = document.querySelector('[data-fcc-bar]');
        var newBar = doc.querySelector('[data-fcc-bar]');
        if (bar && newBar) bar.style.width = newBar.style.width;

        var next = doc.querySelector('[data-fcc-next]');
        var pag = document.querySelector('.fcc-pagination');
        var newPag = doc.querySelector('.fcc-pagination');
        if (pag && newPag) pag.innerHTML = newPag.innerHTML;
        if (next) {
          btn.href = next.getAttribute('href');
          btn.textContent = label;
          btn.removeAttribute('aria-busy');
        } else {
          btn.remove();
        }
      })
      .catch(function () { window.location.href = btn.href; });
  });

  // Mobile floating "Filter & sort" button: appears once the drawer opener scrolls out of view
  function initFloat() {
    var fab = document.querySelector('[data-fcc-float]');
    var opener = document.querySelector('.mobile-facets__open-wrapper');
    if (!fab || !opener || !('IntersectionObserver' in window)) return;
    var grid = document.getElementById('ProductGridContainer');
    var openerVisible = true, gridVisible = false;
    function update() { fab.hidden = openerVisible || !gridVisible; }
    new IntersectionObserver(function (en) { openerVisible = en[0].isIntersecting; update(); }).observe(opener);
    if (grid) new IntersectionObserver(function (en) { gridVisible = en[0].isIntersecting; update(); }).observe(grid);
    fab.addEventListener('click', function () {
      var o = document.querySelector('.mobile-facets__open-wrapper');
      if (o) o.click();
    });
  }

  // Card delivery dates (18 Oct 2026). Same rules as the product page (sections/main-product.liquid):
  // weekend orders start Monday; stock = +2 to +5 working days (Scotia Beading +4),
  // special order = +4 to +7. The card's data-latest holds the upper figure.
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addWorkingDays(start, n) {
    var d = new Date(start), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function dateRange(a, b) {
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }
  function fillDelivery() {
    var els = document.querySelectorAll('[data-fcc-delivery]:not([data-fcc-done])');
    if (!els.length) return;
    var start = new Date();
    start.setHours(0, 0, 0, 0);
    var day = start.getDay();
    if (day === 6) start.setDate(start.getDate() + 2);
    else if (day === 0) start.setDate(start.getDate() + 1);
    els.forEach(function (el) {
      var stock = el.getAttribute('data-fcc-delivery') === 'stock';
      var earliest = parseInt(el.getAttribute('data-delivery-earliest'), 10) || (stock ? 2 : 4);
      var latest = Math.max(parseInt(el.getAttribute('data-delivery-latest') || el.getAttribute('data-latest'), 10) || (stock ? 5 : 7), earliest);
      var target = el.querySelector('[data-fcc-dates]');
      if (target) target.textContent = dateRange(addWorkingDays(start, earliest), addWorkingDays(start, latest));
      el.setAttribute('data-fcc-done', '');
    });
  }
  var fillQueued = false;
  function queueFill() {
    if (fillQueued) return;
    fillQueued = true;
    requestAnimationFrame(function () { fillQueued = false; fillDelivery(); });
  }

  function init() {
    initFloat();
    fillDelivery();
    // Cards added later (filters, sorting, "Load more") get their dates too
    if ('MutationObserver' in window) new MutationObserver(queueFill).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
